import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "content-shape container pt-4"
};
import content from "@/resources/documents/privacy.md";
import Markdown from "vue3-markdown-it";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(Markdown), {
        source: _unref(content),
        class: "document markdown"
      }, null, 8, ["source"])]);
    };
  }
});